import axios from "axios";
import notification from "antd/es/notification";
import helper from "./helper";
const CryptoJS = window.CryptoJS;

const http = axios.create();
http.defaults.baseURL = process.env.REACT_APP_API_URL;
http.defaults.headers.post["Content-Type"] = "application/json";
http.defaults.headers.post["Accept"] = "application/json";

http.interceptors.request.use(
  (config) => {
    const date = new Date().getTime();
    const str = `xmen:${date}`;
    const signed = CryptoJS.HmacSHA256(
      str,
      process.env.REACT_APP_ENCRYPT_KEY
    ).toString(CryptoJS.enc.Hex);
    config.headers["x-encrypt"] = signed;
    config.headers["x-time"] = date;
    config.headers["x-tenant"] = process.env.REACT_APP_TENANT;

    const isMinio = config.url === "/storage/upload";
    const isBodyValid = config.data;
    const noEncrypt = config.headers.noEncrypt;
    const isEncryptEnv = process.env.REACT_APP_USE_ENCRYPTION;
    const isEncrypt =
      config.method !== "get" &&
      !isMinio &&
      !noEncrypt &&
      isBodyValid &&
      parseInt(isEncryptEnv) === 1;

    if (isEncrypt) {
      const enc = helper.encrypt(JSON.stringify(config.data));
      config.data = { data: enc };
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

http.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error) {
      notification.error({
        message: error.response
          ? `${error.response.data.message}`
          : "Terjadi kesalahan pada sistem, silahkan coba kembali nanti.",
        placement: "bottomRight",
        duration: 5,
      });
    }
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("err", error);
    if (error) {
      notification.error({
        message: error.response
          ? `${error.response.data.message}`
          : "Terjadi kesalahan pada sistem, silahkan coba kembali nanti.",
        placement: "bottomRight",
        duration: 5,
      });
    }
    return Promise.reject(error);
  }
);

export default http;
